import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Button as BootstrapButton } from "react-bootstrap";
import styles from "./Button.scss";

const propTypes = {
  /**
   * Appearance of the button
   */
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "light",
    "link",
    "dashed",
    "danger",
  ]),
  /**
   * Button content
   */
  children: PropTypes.node,
  /**
   * Class to modify default styles
   */
  className: PropTypes.string,
};

const defaultProps = {
  variant: "primary",
  children: null,
  className: "",
};

/**
 * Button component based on https://react-bootstrap-v4.netlify.app/components/buttons/
 */
function Button(props) {
  const { children, variant, className, ...rest } = props;

  return (
    <BootstrapButton
      variant={variant}
      className={clsx(styles.base, className)}
      {...rest}
    >
      {children}
    </BootstrapButton>
  );
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
